
const API = (
  process.env.REACT_APP_API_URL || "/api"
).replace(/\/+$/, "");

export default API;
